import React from 'react';
import { MapPin, Clock, ArrowRight } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

export default function LocationPage() {
  const navigate = useNavigate();

  const openGoogleMaps = (coordinates: string) => {
    const url = `https://www.google.com/maps?q=${coordinates}`;
    window.open(url, '_blank');
  };

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
      <div className="flex items-center gap-3 mb-8">
        <MapPin className="h-8 w-8 text-brand-teal" />
        <h1 className="text-3xl font-bold text-brand-teal">Onde Estamos</h1>
      </div>

      <div className="grid gap-8">
        <section className="bg-white p-8 rounded-xl shadow-sm">
          <h2 className="text-2xl font-semibold text-brand-teal mb-4">Nosso Endereço</h2>
          <div className="flex flex-col md:flex-row gap-6">
            <div className="flex-1 space-y-4">
              <p className="text-gray-600">
                <strong>Igreja Sal da Terra Brasília</strong><br />
                SGAS 915 Lote 72/74<br />
                Asa Sul, Brasília - DF<br />
                CEP: 70390-150
              </p>
              
              <div className="space-y-2">
                <h3 className="font-semibold text-brand-teal">Horários de Culto</h3>
                <div className="flex items-start gap-2">
                  <Clock className="h-5 w-5 text-brand-teal shrink-0 mt-0.5" />
                  <div>
                    <p><strong>Domingo:</strong> 18h</p>
                    <p><strong>Quarta-feira:</strong> 20h</p>
                  </div>
                </div>
              </div>
              
              <button
                onClick={() => openGoogleMaps("-15.8276,-47.9258")}
                className="bg-brand-teal text-white px-6 py-3 rounded-xl hover:bg-brand-teal/90 transition-colors shadow-elevation-1 hover:shadow-elevation-2 active:shadow-elevation-1 flex items-center gap-2"
              >
                <MapPin className="h-5 w-5" />
                Ver no Google Maps
              </button>
            </div>
            
            <div className="flex-1 aspect-video bg-gray-200 rounded-lg overflow-hidden">
              <iframe 
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3839.1853670277!2d-47.92799908514706!3d-15.827599989035196!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x935a3b20a5c5c4e7%3A0x5f0e8c1d0ad5e3c8!2sSGAS%20915%20-%20Asa%20Sul%2C%20Bras%C3%ADlia%20-%20DF!5e0!3m2!1spt-BR!2sbr!4v1645564857185!5m2!1spt-BR!2sbr" 
                width="100%" 
                height="100%" 
                style={{ border: 0 }} 
                allowFullScreen 
                loading="lazy"
                title="Localização da Igreja"
              ></iframe>
            </div>
          </div>
        </section>

        <section className="bg-white p-8 rounded-xl shadow-sm">
          <h2 className="text-2xl font-semibold text-brand-teal mb-4">Como Chegar</h2>
          <div className="space-y-4 text-gray-600">
            <div>
              <h3 className="font-semibold text-brand-teal">De Carro</h3>
              <p>Estacionamento amplo e gratuito no local.</p>
            </div>
            
            <div>
              <h3 className="font-semibold text-brand-teal">De Transporte Público</h3>
              <p>Linhas de ônibus que passam próximo ao local: 156, 174, 108.</p>
              <p>Estação de metrô mais próxima: Estação 114 Sul (aproximadamente 15 minutos a pé).</p>
            </div>
          </div>
        </section>

        <section className="bg-white p-8 rounded-xl shadow-sm">
          <h2 className="text-2xl font-semibold text-brand-teal mb-4">Outras Unidades</h2>
          <div className="grid gap-4 md:grid-cols-2">
            <div className="p-4 bg-brand-light rounded-lg">
              <h3 className="font-semibold text-brand-teal mb-2">Sal da Terra Águas Claras</h3>
              <p className="text-gray-600 mb-4">Rua das Paineiras, Quadra 203, Lote 5 - Águas Claras</p>
              <button
                onClick={() => openGoogleMaps("-15.8456,-48.0123")}
                className="text-brand-teal hover:text-brand-teal/80 flex items-center gap-1"
              >
                <MapPin className="h-4 w-4" />
                Ver no mapa
                <ArrowRight className="h-4 w-4" />
              </button>
            </div>
            
            <div className="p-4 bg-brand-light rounded-lg">
              <h3 className="font-semibold text-brand-teal mb-2">Sal da Terra Taguatinga</h3>
              <p className="text-gray-600 mb-4">QNM 34 Área Especial 01 - Taguatinga Norte</p>
              <button
                onClick={() => openGoogleMaps("-15.8123,-48.0654")}
                className="text-brand-teal hover:text-brand-teal/80 flex items-center gap-1"
              >
                <MapPin className="h-4 w-4" />
                Ver no mapa
                <ArrowRight className="h-4 w-4" />
              </button>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
}